import { useParams } from 'react-router-dom';
import { useGetPostCommentsQuery } from '../../store/api/postApi';
import CommentSection from '../../components/CommentSection';
import { useCommentOnPostMutation } from '../../store/api/postApi';
import { useSearchParams } from "react-router-dom";
import { useGetPostByIdQuery } from '../../store/api/postApi';
import { useAuth } from '../../hooks/useAuth';
export default function PostCommentsPage() {
  const [searchParams] = useSearchParams();
  const type = searchParams.get("type") || "Post";
  const { postId } = useParams();
  
  //const auth = useAuth();
  const { user } = useAuth();
  //console.log("AUTH:", auth);
  const {
    data: comments = [],
    isLoading,
  } = useGetPostCommentsQuery({postId, type});

  const [commentOnPost, { isLoading: isCommenting }] =
    useCommentOnPostMutation();
 
    const { data: post } = useGetPostByIdQuery({
      postId,
      type
    });
  const handleComment = async (text, parentCommentId = null) => {
    await commentOnPost({
      postId,
      commentText: text,
      parentCommentId,
      type,
    });
  };
  console.log("POST:", post);
console.log("POST OWNER ID:", post?.user?.id);
console.log("CURRENT USER:", user?.userId);

  return (
    <div style={{ maxWidth: 600, margin: '0 auto', padding: 20 }}>
      <h2>Comments</h2>

      <CommentSection
        postId={postId}
        comments={comments}
        commentsCount={comments.length}
        onSubmitComment={handleComment}
        isCommenting={isCommenting || isLoading}
        currentUser={user}
        postOwnerId={post?.user?.id} 
      />
    </div>
  );
}